class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop: open the dropdown on hover, not just on click.
    const hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.addEventListener('mouseenter', () => {
      if (!hoverMedia.matches) return;
      clearTimeout(this.hoverCloseTimer);
      this.mainDetailsToggle.open = true;
      summary.setAttribute('aria-expanded', true);
    });
    this.addEventListener('mouseleave', () => {
      if (!hoverMedia.matches) return;
      this.hoverCloseTimer = setTimeout(() => this.close(), 150);
    });
    // A mouse click on an already hover-opened menu should not slam it shut.
    summary.addEventListener('click', (event) => {
      if (hoverMedia.matches && event.detail > 0 && this.mainDetailsToggle.open) event.preventDefault();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
